import { useApiDealsV1DealChoicesList } from 'api';
import { useTranslation } from 'i18n';
import { useState } from 'react';
import { Autocomplete } from 'ui';

type DealChoice = {
  id: number;
  name: string;
};
export const DealAutocomplete = ({
  required,
  onSelectDeal,
  defaultValue,
}: {
  required?: boolean;
  onSelectDeal: (deal: DealChoice | null) => void;
  defaultValue?: number;
}) => {
  const { t } = useTranslation('orders');
  const [value, setValue] = useState<DealChoice | null>(
    defaultValue ? { id: defaultValue, name: `Deal #${defaultValue}` } : null
  );
  const [query, setQuery] = useState(defaultValue?.toString() || '');

  const { data, isLoading } = useApiDealsV1DealChoicesList({
    search: query,
  });

  return (
    <Autocomplete
      options={data?.results || []}
      loading={isLoading}
      value={value}
      required={required}
      getOptionLabel={(item) => item.name}
      isOptionEqualToValue={(option, value) => {
        return value === undefined || option?.id?.toString() === (value?.id ?? value)?.toString();
      }}
      placeholder={t('dealAutocomplete.placeholder')}
      onChange={(_event, newValue) => {
        setValue(newValue);
        onSelectDeal(newValue);
      }}
      filterOptions={(options, state) => {
        setQuery(state.inputValue);
        return options;
      }}
    />
  );
};
